import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const SmsPolicy = () => {
  return (
    <>
      <Helmet>
        <title>SMS Policy - Miranda Landa Services LLC</title>
        <meta name="description" content="SMS and Text Messaging Policy for Miranda Landa Services LLC. Learn about our text message communications and how to opt out." />
      </Helmet>

      <section style={{
        background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
        color: 'white',
        padding: '4rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: '800px', margin: '0 auto'}}>
          <h1 style={{fontSize: '2.5rem', fontWeight: '800', marginBottom: '1rem'}}>
            SMS & Text Messaging Policy
          </h1>
          <p style={{fontSize: '1.1rem', opacity: 0.95}}>
            Last Updated: December 4, 2024
          </p>
        </div>
      </section>

      <section style={{padding: '4rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '900px', margin: '0 auto'}}>
          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              1. SMS Program Overview
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              Miranda Landa Services LLC offers SMS text messaging services to provide you with updates, reminders, 
              and information about your business capital consultation and funding preparation process. This policy 
              explains how our SMS program works and your rights regarding text message communications.
            </p>
            <div style={{
              background: '#f0fdf4',
              padding: '1.5rem',
              borderRadius: '8px',
              borderLeft: '4px solid #10b981'
            }}>
              <p style={{fontSize: '1rem', color: '#065f46', fontWeight: '600', marginBottom: '0.75rem'}}>
                Our A2P Campaign Purpose:
              </p>
              <p style={{fontSize: '0.95rem', color: '#065f46', lineHeight: '1.7'}}>
                We provide business capital consulting services to help businesses prepare for funding opportunities. 
                Customers opt in via our website contact form to receive appointment confirmations, consultation reminders, 
                document requests, and updates about their funding preparation process. We connect businesses with financial 
                institutions - we do NOT issue loans or make lending decisions.
              </p>
            </div>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              2. Consent to Receive Text Messages
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              By providing your mobile phone number and opting in to receive SMS messages from Miranda Landa Services LLC, 
              you expressly consent to receive:
            </p>
            <ul style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', paddingLeft: '2rem', marginBottom: '1.5rem'}}>
              <li>Business financing updates</li>
              <li>Funding consultation reminders</li>
              <li>Loan option follow-ups</li>
              <li>Updates about your consultation request</li>
              <li>Document requirements and preparation guidance</li>
              <li>Financial strategy session notifications</li>
            </ul>
            <div style={{
              background: '#f9fafb',
              padding: '1.5rem',
              borderRadius: '8px',
              border: '1px solid #e5e7eb'
            }}>
              <p style={{fontSize: '1rem', color: '#374151', fontWeight: '600', marginBottom: '1rem'}}>
                Sample Messages You May Receive:
              </p>
              <ul style={{fontSize: '0.9rem', color: '#6b7280', lineHeight: '1.7', paddingLeft: '1.5rem', listStyle: 'none'}}>
                <li style={{marginBottom: '0.75rem'}}>
                  💬 "Thank you for contacting Miranda Landa Services LLC. Your consultation request is received. Reply STOP to opt out."
                </li>
                <li style={{marginBottom: '0.75rem'}}>
                  💬 "Your funding assessment is ready. A consultant will contact you shortly. Reply STOP to unsubscribe."
                </li>
                <li style={{marginBottom: '0.75rem'}}>
                  💬 "We need additional details to continue your funding consultation. Reply STOP to opt out."
                </li>
                <li style={{marginBottom: '0.75rem'}}>
                  💬 "Your financial strategy session is scheduled. Reply STOP to cancel updates."
                </li>
                <li>
                  💬 "Your consultation report is available. Reply STOP to unsubscribe."
                </li>
              </ul>
            </div>
          </div>

          <div style={{
            background: '#fef3c7',
            padding: '2rem',
            borderRadius: '12px',
            border: '2px solid #f59e0b',
            marginBottom: '3rem'
          }}>
            <h3 style={{fontSize: '1.3rem', fontWeight: '700', color: '#92400e', marginBottom: '1rem'}}>
              📱 TCPA Compliance Notice
            </h3>
            <p style={{fontSize: '1rem', color: '#78350f', lineHeight: '1.7'}}>
              By opting in to receive SMS messages, you provide your express written consent under the Telephone 
              Consumer Protection Act (TCPA) to receive automated marketing text messages from Miranda Landa Services LLC 
              at the mobile number provided. Consent is not a condition of purchase. Message and data rates may apply.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              3. Message Frequency
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Message frequency varies depending on your consultation status and preferences. You may receive up to 
              10 messages per month. During active consultation periods, you may receive more frequent updates. 
              We will never send excessive or spam messages.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              4. Message and Data Rates
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Standard message and data rates may apply based on your mobile carrier's plan. Miranda Landa Services LLC 
              does not charge for text messages, but your carrier may charge you for messages sent and received. 
              Please contact your mobile carrier for details about your messaging plan.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              5. How to Opt Out (STOP)
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              You can opt out of receiving SMS messages at any time by:
            </p>
            <div style={{
              background: '#f0fdf4',
              padding: '1.5rem',
              borderRadius: '8px',
              borderLeft: '4px solid #10b981',
              marginBottom: '1rem'
            }}>
              <p style={{fontSize: '1.1rem', color: '#065f46', fontWeight: '600', marginBottom: '0.75rem'}}>
                Text "STOP" to our SMS number
              </p>
              <p style={{fontSize: '0.95rem', color: '#065f46', lineHeight: '1.6'}}>
                Reply with the word STOP, END, CANCEL, UNSUBSCRIBE, or QUIT to any message you receive from us. 
                You will receive a confirmation message that you have been unsubscribed. After this, you will no 
                longer receive SMS messages from us unless you opt in again.
              </p>
            </div>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              You can also contact us directly at <a href="mailto:sms@mirandaconnects.com" style={{color: '#059669'}}>sms@mirandaconnects.com</a> to opt out.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              6. Help and Support (HELP)
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              For help or more information about our SMS program:
            </p>
            <div style={{
              background: '#f0fdf4',
              padding: '1.5rem',
              borderRadius: '8px',
              borderLeft: '4px solid #10b981',
              marginBottom: '1rem'
            }}>
              <p style={{fontSize: '1.1rem', color: '#065f46', fontWeight: '600', marginBottom: '0.75rem'}}>
                Text "HELP" to our SMS number
              </p>
              <p style={{fontSize: '0.95rem', color: '#065f46', lineHeight: '1.6'}}>
                Reply with the word HELP to any message you receive from us, and you will receive information 
                about the program and how to contact us.
              </p>
            </div>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              You can also email us at <a href="mailto:support@mirandaconnects.com" style={{color: '#059669'}}>support@mirandaconnects.com</a> for assistance.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              7. Supported Carriers
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              Our SMS program is supported by all major U.S. mobile carriers, including:
            </p>
            <p style={{fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.7', paddingLeft: '1rem'}}>
              AT&T, T-Mobile, Verizon, Sprint, Boost Mobile, Cricket Wireless, MetroPCS, U.S. Cellular, Virgin Mobile, 
              and many others. If you experience issues receiving messages, please contact your carrier or reach out to us.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              8. Privacy and Data Protection
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Your mobile phone number and SMS preferences are protected under our <Link to="/privacy" style={{color: '#059669', textDecoration: 'underline'}}>Privacy Policy</Link>. 
              We will not sell, rent, or share your mobile number with third parties for their marketing purposes 
              without your explicit consent. We may share your information with service providers who help us deliver 
              SMS messages and with financial institutions as part of our consultation services.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              9. Changes to Phone Number
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              If you change your mobile phone number, please notify us immediately to update your contact information 
              and ensure you continue to receive important messages. You can update your number by contacting us or 
              through your account settings if applicable.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              10. Liability and Disclaimer
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Miranda Landa Services LLC and mobile carriers are not liable for delayed or undelivered messages. 
              We are not responsible for any charges or fees imposed by your mobile carrier. Message delivery is 
              subject to your carrier's network availability and may be affected by factors beyond our control.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              11. Changes to SMS Policy
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              We may update this SMS Policy from time to time. We will notify you of any material changes by sending 
              a text message or by posting the updated policy on our website. Your continued participation in our SMS 
              program after changes are made constitutes acceptance of the updated policy.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              12. Contact Information
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              For questions about our SMS program or this policy:
            </p>
            <div style={{
              background: '#f0fdf4',
              padding: '1.5rem',
              borderRadius: '8px',
              borderLeft: '4px solid #10b981'
            }}>
              <p style={{fontSize: '1rem', color: '#065f46', marginBottom: '0.5rem'}}>
                <strong>Miranda Landa Services LLC</strong>
              </p>
              <p style={{fontSize: '1rem', color: '#065f46', marginBottom: '0.5rem'}}>
                SMS Inquiries: <a href="mailto:sms@mirandaconnects.com" style={{color: '#059669'}}>sms@mirandaconnects.com</a>
              </p>
              <p style={{fontSize: '1rem', color: '#065f46'}}>
                Support: <a href="mailto:support@mirandaconnects.com" style={{color: '#059669'}}>support@mirandaconnects.com</a>
              </p>
            </div>
          </div>

          <div style={{
            background: '#f0fdf4',
            padding: '2rem',
            borderRadius: '12px',
            border: '2px solid #10b981',
            textAlign: 'center'
          }}>
            <p style={{fontSize: '1.1rem', color: '#065f46', lineHeight: '1.7', marginBottom: '1rem'}}>
              <strong>Quick Reference</strong>
            </p>
            <div style={{display: 'grid', gap: '0.75rem', fontSize: '1rem', color: '#065f46'}}>
              <p>📱 <strong>To Opt Out:</strong> Text STOP</p>
              <p>❓ <strong>For Help:</strong> Text HELP</p>
              <p>📧 <strong>SMS Support:</strong> sms@mirandaconnects.com</p>
              <p>📧 <strong>General Support:</strong> support@mirandaconnects.com</p>
            </div>
          </div>

          <div style={{marginTop: '3rem', textAlign: 'center', display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap'}}>
            <Link to="/privacy" style={{
              background: 'white',
              color: '#059669',
              padding: '1rem 2rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1rem',
              border: '2px solid #059669'
            }}>
              Privacy Policy
            </Link>
            <Link to="/terms" style={{
              background: 'white',
              color: '#059669',
              padding: '1rem 2rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1rem',
              border: '2px solid #059669'
            }}>
              Terms of Service
            </Link>
            <Link to="/contact" style={{
              background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1rem'
            }}>
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default SmsPolicy;
